/**
 * Ensures the provided value is an array.
 * If the value is already an array, returns it as-is.
 * If the value is null or undefined, returns an empty array.
 * Otherwise, wraps the value in an array.
 *
 * @param value The value to ensure is an array
 * @returns An array containing the value(s)
 */
export function ensureArray<T>(value: T | T[]): T[] {
  if (value === null || value === undefined) {
    return [];
  }

  if (Array.isArray(value)) {
    return value;
  }

  return [value];
}
